import styled, { keyframes } from 'styled-components';

import { flexAllCenter } from 'styles/mixins';
import { COLORS } from 'styles/style-constants';

const pulse = keyframes`
    from { opacity: 0.5; }
    to { opacity: 1; }
`;

export const Container = styled.div`
    width: 100%;
`;

export const SkeletonStack = styled.div<{ $gap?: string }>`
    display: flex;
    flex-direction: column;
    gap: ${({ $gap }) => $gap ?? '1.6rem'};
    min-width: 0;
`;

export const SkeletonRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1.6rem;
`;

export const Bar = styled.div.attrs({ 'aria-hidden': true })<{
    $width: string;
    $height?: string;
    $heading?: boolean;
    $circle?: boolean;
}>`
    width: ${({ $width }) => $width};
    max-width: ${({ $circle, $width }) => ($circle ? $width : '100%')};
    height: ${({ $circle, $width, $height, $heading }) =>
        $circle ? $width : ($height ?? ($heading ? '2.4rem' : '1.2rem'))};
    flex-shrink: 0;
    border-radius: ${({ $circle }) => ($circle ? '50%' : '0.6rem')};
    background: ${COLORS.gray100};
    animation: ${pulse} 1.2s ease-in-out infinite alternate;

    @media (prefers-reduced-motion: reduce) {
        animation: none;
    }
`;

export const ErrorState = styled.div<{ $compact?: boolean }>`
    ${flexAllCenter};
    flex-direction: column;
    gap: 1.6rem;
    min-height: 32rem;
    padding: 3.2rem;
    color: ${COLORS.textGray};
    text-align: center;

    p {
        margin: 0;
    }

    ${({ $compact }) =>
        $compact &&
        `
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-start;
        min-height: 0;
        padding: 1.6rem 0;
        text-align: left;
    `}
`;
